
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { getCategoryColor, getCategoryLabel, getCategoryTotals } from './categoryUtils';
import { Activity } from '@/types/program';

interface CategoryPillsProps {
  activities: Activity[];
}

export const CategoryPills = ({ activities }: CategoryPillsProps) => {
  const categoryTotals = getCategoryTotals(activities);

  return (
    <div className="flex flex-wrap gap-2 mb-6 pb-4 border-b">
      {Object.entries(categoryTotals).map(([category, totalMinutes]) => (
        <Badge 
          key={category} 
          className={`${getCategoryColor(category)} px-3 py-1`}
        >
          {getCategoryLabel(category)} ({totalMinutes} min)
        </Badge>
      ))}
    </div>
  );
};
